import {DatePickerValidator} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateInput/DatePickerPopoverSingleDateInput.types.ts";

export const datePickerDefaultInputValidators: DatePickerValidator[] = [
  {
    validate: (value: string) => {
      // Basic validation to check if the input is a valid date format
      const date = new Date(value); // Doesn't need to be timezone aware, as we are using parseToAccountTimeZone later
      return !isNaN(date.getTime());
    },
    errorMessage: "Invalid date format",
  },
];
